export default "__VITE_ASSET__11daa93b__"